import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import {
	ModalDialogueCaptionModifier,
	ModalDialogueHeader
} from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-header/ModalDialogueHeader';
import { ModalDialogueSection } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSection';
import { ModalDialogueSectionName } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSectionName';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonSecondary, ButtonSecondaryStatus } from 'presentation/ui/partials/button/button-secondary/ButtonSecondary';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { CyclotronProductViewModel } from 'services/nuclide/domain/model/CyclotronProductModel';

export interface CyclotronProductUndoCompletelyAppliedFormProps {
	/**
	 * Cyclotron product
	 */
	cyclotronProduct: CyclotronProductViewModel;
	/**
	 * Handle update
	 */
	onUpdate: () => void;
	/**
	 * Handle dismiss
	 */
	onDismiss: () => void;
}

export const CyclotronProductUndoCompletelyAppliedForm = (props: CyclotronProductUndoCompletelyAppliedFormProps): JSX.Element => {
	const { cyclotronProduct, onUpdate, onDismiss } = props;

	const l10nContext = useContext(L10nContext);

	const modalMessage = {
		first: l10nContext.translate('view.cyclotronProducts.modal.action.undoCompletelyApplied.message.first', 'Wollen Sie den Status "Vollständig appliziert" für das Radionuklid'),
		last: l10nContext.translate('view.cyclotronProducts.modal.action.undoCompletelyApplied.message.last', 'wirklich aufheben?')
	};

	return (
		<>
			<ModalDialogueHeader
				captionText={l10nContext.translate('common.modal.captionAttention', 'Achtung')}
				captionIcon={IconIdentifier.ALERT}
				captionModifier={ModalDialogueCaptionModifier.SMALL_CAPTION}
			/>
			<ModalDialogueSection>
				<>
					{modalMessage.first} <b>{cyclotronProduct.Name}</b> {modalMessage.last}
				</>
			</ModalDialogueSection>

			<ModalDialogueSection section={ModalDialogueSectionName.SECTION_FOOTER}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.button.abort', 'Abbrechen')}
							onClick={onDismiss}
						/>
					</ColumnLayoutSection>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.modal.undoCompletelyAppliedConfirm', 'Ja, den Status aufheben')}
							status={ButtonSecondaryStatus.ATTENTION}
							icon={IconIdentifier.DECAY}
							onClick={onUpdate}
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</ModalDialogueSection>
		</>
	);
};
